import { PayrollRunsYear } from "../paths";
import { getDefaultPayrollRunYear, getPayrollRunYears } from "../utils";

/**
 * The payroll-runs dashboard year a pay statement belongs to, for deep-linking
 * into `/member/payroll-runs/:year/...`.
 *
 * The dashboard only offers a fixed set of years, so a `payDate` outside that
 * set — or an absent one, which a statement without a pay date has — falls back
 * to the default year rather than producing a URL the dashboard cannot render.
 */
export const selectorPayrollRunsYear = (
  payDate?: Date | null
): PayrollRunsYear => {
  if (!payDate) {
    return getDefaultPayrollRunYear();
  }

  const year = String(payDate.getFullYear());

  return getPayrollRunYears().includes(year)
    ? year
    : getDefaultPayrollRunYear();
};
